// src/pages/Schedule/SupervisorSchedule.js
import React from "react";
import AdminSchedule from "./AdminSchedule";
import "./SupervisorReadOnly.css";

export default function SupervisorSchedule() {
  return (
    <div className="supervisor-readonly">
      <AdminSchedule readOnly />
    </div>
  );
}
